import { ComputationOptions } from "./computeMaterialPrice";
import { OptimizedMachineTimes } from "./computeOptimizedMachineTimes";
import { OptimizedMaterialCosts } from "./computeOptimizedMaterialCosts";
import {
  computeQuoteRequestLinePrice,
  QuoteRequestLineForComputing,
} from "./computeQuoteRequestLinePrice";

type Params = {
  salesMarginRatio?: number | null;
  quoteRequestLine: QuoteRequestLineForComputing;
  isQuotePrice?: boolean;
  optimizedMachineTimes: OptimizedMachineTimes;
  optimizedMaterialCosts: OptimizedMaterialCosts;
};

export const computeQuoteRequestLinePriceWithSalesMargin = (
  {
    salesMarginRatio,
    quoteRequestLine,
    isQuotePrice,
    optimizedMachineTimes,
    optimizedMaterialCosts,
  }: Params,
  options: ComputationOptions,
): {
  seriesPriceWithSalesMargin: number;
  partPriceWithSalesMargin: number;
  seriesSalesMargin: number;
  partSalesMargin: number;
  partCumulativeMargin: number;
  seriesCumulativeMargin: number;
} => {
  const { seriesPrice, partPrice, partMarginPrice, seriesMarginPrice } =
    computeQuoteRequestLinePrice(
      {
        quoteRequestLine,
        isQuotePrice,
        optimizedMachineTimes,
        optimizedMaterialCosts,
      },
      options,
    );

  const partSalesMargin = partPrice * ((salesMarginRatio || 0) / 100);

  const seriesSalesMargin = seriesPrice * ((salesMarginRatio || 0) / 100);

  const partPriceWithSalesMargin = partPrice + partSalesMargin;

  const seriesPriceWithSalesMargin = seriesPrice + seriesSalesMargin;
  const partCumulativeMargin = partMarginPrice + partSalesMargin;
  const seriesCumulativeMargin = seriesMarginPrice + seriesSalesMargin;

  return {
    seriesPriceWithSalesMargin,
    partPriceWithSalesMargin,
    seriesSalesMargin,
    partSalesMargin,
    partCumulativeMargin,
    seriesCumulativeMargin,
  };
};
